import { Photo } from "@/components/Photo";

const SIZES = { sm: "h-10 w-10 text-sm", md: "h-14 w-14 text-lg", lg: "h-24 w-24 text-3xl", xl: "h-32 w-32 text-4xl" };

/** Profile photo (fetched with credentials) or initials fallback. */
export const StudentAvatar = ({ student, size = "md", className = "", testid }) => {
  const initials = `${student?.first_name?.[0] || ""}${student?.last_name?.[0] || ""}`.toUpperCase() || "?";
  const base = `${SIZES[size]} rounded-2xl shrink-0 overflow-hidden ${className}`;
  if (student?.photo_path)
    return <Photo path={student.photo_path} alt={`${student.first_name} ${student.last_name}`}
                  className={`${base} object-cover`} testid={testid || "student-avatar"} />;
  return (
    <span className={`${base} bg-blue-50 text-[#3B82F6] grid place-items-center font-display font-bold`}
          data-testid={testid || "student-avatar"}>{initials}</span>
  );
};
